import { render, staticRenderFns } from "./search.vue?vue&type=template&id=45461e1a&scoped=true"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"
import style0 from "vue-advanced-search/dist/AdvancedSearch.css?vue&type=style&index=0&id=45461e1a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45461e1a",
  null
  
)

export default component.exports